import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

import { createQueryClient } from "@/app/queryClient";
import { AuthProvider } from "@/auth/AuthProvider";
import { AppRouter } from "@/router";

export default function App() {
  // useState garante um QueryClient por montagem (importante nos testes).
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </QueryClientProvider>
  );
}
